var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eden-page-header',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle}},[_c('template',{slot:"actions"},[_c('el-button',{staticClass:"mx-0",attrs:{"type":"primary"}},[_vm._v("Save Schedule ")])],1)],2),_c('schedule-dates',{on:{"set-date":_vm.setDate}}),_c('schedule-orders',{attrs:{"service":_vm.service,"date":_vm.date}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }